import type { User } from '@sentry/vue';
import * as Sentry from '@sentry/vue';
import { AxiosError } from 'axios';

import { useBrokerStore } from '@/features/Broker/store';
import { useGlobalStore } from '@/features/Global/store';
import type {
  ErrorToHandle,
  VGLErrorHandlerService,
} from '@/services/errorHandler/types';

export class SentryService implements VGLErrorHandlerService {
  static buildSentryUser(): User {
    const brokerData = useBrokerStore().broker.data;

    return {
      email: brokerData?.email,
      id: brokerData?.id.toString(),
    };
  }

  handle(error: ErrorToHandle): void {
    Sentry.setTag('sparte', useGlobalStore().getSparte);
    Sentry.setTag('errorCode', error.error.getErrorCode());
    Sentry.setUser(SentryService.buildSentryUser());

    Sentry.withScope((scope) => {
      const additionalData = error.error.getAdditionalData();
      const additionalMessage = error.error.getAdditionalMessage();
      const errorCause = error.error.cause;

      if (additionalData !== undefined) {
        scope.setExtra('additionalData', additionalData);
      }

      if (additionalMessage !== undefined) {
        scope.setExtra('additionalMessage', additionalMessage);
      }

      if (errorCause !== undefined) {
        scope.setExtra('errorCause', errorCause);

        if (errorCause instanceof AxiosError) {
          scope.setExtra('axios-request', errorCause.request);
          scope.setExtra('axios-response', errorCause.response);
        }
      }

      scope.setExtras({
        info: error.info,
        timestamp: error.timestamp,
        instance: error.instance,
        errorStackTrace: error.stackTrace,
      });

      Sentry.captureException(error.error);
    });
  }
}
